/**
 * Status Bar
 *
 * Bottom bar showing current skill and transformation status
 */

import { useProjectStore } from '@/stores/projectStore';
import { ProcessMonitor } from '../monitoring/ProcessMonitor';

export const StatusBar: React.FC = () => {
  // Subscribe to the relevant state directly so component re-renders on changes
  const selectedArtifact = useProjectStore((state) => {
    const { activeProjectId, projects, ui } = state;
    if (!activeProjectId || !ui.selectedArtifactId) return null;
    return projects[activeProjectId]?.artifacts?.[ui.selectedArtifactId] || null;
  });

  return (
    <div className="h-8 border-t border-border bg-background flex items-center justify-between px-4 text-xs">
      {/* Left side - Current artifact name and type */}
      <div className="text-muted-foreground">
        {selectedArtifact ? (
          <>
            <span className="font-medium">{selectedArtifact.type}</span>
            <span className="mx-2">•</span>
            <span>{selectedArtifact.name}</span>
          </>
        ) : (
          'No artifact selected'
        )}
      </div>

      {/* Right side - Process Monitor */}
      <div className="flex items-center gap-2">
        <ProcessMonitor />
      </div>
    </div>
  );
};
